
export enum CATEGORY_MODES {
    ASK_QUESTIONS = "ASK_QUESTIONS",
    BASE = "BASE"
}